import axios from "axios";

export const fetchImportTaskCounterTemplate = async (data: any) => {
  const body = { file: data.file, organizationId: data.organizationId };
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.post(
    `${baseTaskUrl}/TaskCounterTemplate/import`,
    body,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    }
  );
};
